export const environment = {
  name: "production",
  production: true,
  protuneApiUrl: "https://app.gtprotune.com/api"
};
